// docs/104 BD4 — the instrument a bard plays (calling ids 61–65), read from the SDK's
// `hero_calling` cache at the moment a song plays, so its notes take the instrument's colour. No
// subscription of its own: the encounter session already holds the World's calling rows.
import { getConn } from '../net/connection';

/** The spellbook (`?spells=1`) plays its bard on the instrument picked there, with no World to read. */
let override: number | undefined;
export const playForBook = (instrument: number | undefined): void => { override = instrument; };

/** The bard's instrument calling id, or undefined (not a bard, no World, no row). */
export function instrumentOf(heroId: number | bigint | undefined): number | undefined {
  if (override !== undefined) return override;
  if (heroId === undefined) return undefined;
  const c = getConn() as unknown as { db?: { heroCalling?: { iter(): Iterable<{ heroId: bigint; pick: number }> } } } | undefined;
  const rows = c?.db?.heroCalling?.iter();
  if (!rows) return undefined;
  const h = BigInt(heroId);
  for (const r of rows) if (r.heroId === h) return r.pick >= 61 && r.pick <= 65 ? r.pick : undefined;
  return undefined;
}
